import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfSupplierRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-listdefinition-supplier";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
